export default "__VITE_ASSET__gD499Gsq__"